import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

@Component({
  selector: 'h3-region-of-interest-setting-toggle',
  templateUrl: './region-of-interest-setting-toggle.component.html',
  styleUrl: './region-of-interest-setting-toggle.component.scss',
  imports: [MatSlideToggleModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RegionOfInterestSettingToggleComponent {
  @Input({ required: true }) label!: string;
  @Input({ required: true }) name!: string;
  @Input({ required: true }) value!: string;
  @Input({ required: true }) checked!: boolean;
  @Input() disabled = false;
  @Output() changeEventEmitter = new EventEmitter<void>();
}
